import React, { Component } from 'react';
import srcMenuCreche from '../styles/img/icon-vie-creche-white.svg';
import srcMenuMenus from '../styles/img/menu-menus.svg';
import srcMenuEvenements from '../styles/img/menu-evenements.svg';
import srcMenuEquipe from '../styles/img/menu-equipe.svg';
import srcMenuCommunaute from '../styles/img/menu-communaute.svg';
import srcMenuAccueil from '../styles/img/menu-accueil.svg';
import srcIconPhoto from '../styles/img/icon-photo.svg';
import { Link } from "react-router-dom";
import CameraComponent from "./CameraComponent"
import ShaireModal from "./ShaireModal"
import SelectParentModal from "./SelectParentModal"
import jwt_decode from 'jwt-decode';
import { connect } from 'react-redux'
import InterCom from "./InterCom"
import { API } from "../const";
import { Service } from "../modules/service/service";
import { withTranslation } from 'react-i18next';

const MenuCreche = () => <object data={srcMenuCreche} style={{ width: "40px", height: "40px", pointerEvents: "none", cursor: "pointer" }} type="image/svg+xml" className="img-fluid" />
const MenuMenus = () => <object data={srcMenuMenus} type="image/svg+xml" style={{ width: "40px", height: "40px", pointerEvents: "none", cursor: "pointer" }} className="img-fluid" />
const MenuEvenements = () => <object data={srcMenuEvenements} type="image/svg+xml" style={{ width: "40px", height: "40px", pointerEvents: "none", cursor: "pointer" }} className="img-fluid" />
const MenuEquipe = () => <object data={srcMenuEquipe} type="image/svg+xml" style={{ width: "40px", height: "40px", pointerEvents: "none", cursor: "pointer" }} className="img-fluid" />
const MenuCommunaute = () => <object data={srcMenuCommunaute} type="image/svg+xml" style={{ width: "40px", height: "40px", pointerEvents: "none", cursor: "pointer" }} className="img-fluid" />
const MenuAccueil = () => <object data={srcMenuAccueil} type="image/svg+xml" style={{ width: "40px", height: "40px", pointerEvents: "none", cursor: "pointer" }} className="img-fluid" />
const IconPhoto = () => <object data={srcIconPhoto} type="image/svg+xml" style={{ width: "50px", height: "50px", pointerEvents: "none", cursor: "pointer" }} className="img-fluid" />

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openModal: false,
      openSelectModal: false,
      openShaireModal: false,
      video: {},
      photo: '',
      file: null,
      base64Image: '',
      loading: false,
      appUser:{}
    }

    this.shaireWith = this.shaireWith.bind(this)
    this.onCloseModaleCamera = this.onCloseModaleCamera.bind(this)
    this.onOpenSelectModale = this.onOpenSelectModale.bind(this)
    this.onOpenSaireModale = this.onOpenSaireModale.bind(this)
    this.BackCamera = this.BackCamera.bind(this)
    this.handleClickAdmin = this.handleClickAdmin.bind(this)
    this.onOpenShareVideoModale = this.onOpenShareVideoModale.bind(this)
    this.cleanData = this.cleanData.bind(this)
    this.appUserInit();
  }
  appUserInit = () => {
    let token = localStorage.getItem("token");
    let tokenDecoded = token ? jwt_decode(token) : "";
    const response = Service.get(`${API}api/creche/agents/${tokenDecoded.AGENT_ID}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    response.then((res) => {
      this.setState({
        appUser: {
          id: res.data.email,
          email: res.data.email,
          name: res.data.prenom
        }
      })
    });

  }
  cleanData = () => {
    this.setState({
      video: {},
      photo: '',
      file: null,
      base64Image: '',
    })
  }

  shaireWith() {
    this.setState({
      openShaireModal: false,
      openSelectModal: true
    })
  }

  BackCamera() {
    this.setState({
      openModal: true,
      openShaireModal: false,
      openSelectModal: false
    })
  }

  onCloseModaleCamera = () => {

    this.setState({
      openModal: false,
      openSelectModal: false,
      openShaireModal: false
    })
  }

  onOpenModaleCamera = (event) => {
    event.preventDefault();
    this.setState({
      openModal: true
    })
  }

  onOpenSelectModale = (event) => {
    event.preventDefault();
    this.setState({
      openSelectModal: true
    })
  }

  handleClickAdmin = (event) => {
    let token = localStorage.getItem("token");
    let tokenDecoded = token ? jwt_decode(token) : "";
     if (tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE") {
    } else {
      event.preventDefault();
    }
  }

  onOpenSaireModale = (video, src, base64Image) => {
    if (base64Image !== undefined) {
      let reader = new FileReader();
      let file = src;
      reader.onloadend = () => {
        this.setState({
          file: file,
          openModal: false,
          openShaireModal: true,
          video: video,
          photo: base64Image,
        });
      }
      reader.readAsDataURL(file)
    }
  }


  onOpenShareVideoModale = (video) => {
    const file = new File([video], 'file', { type: "video/mp4" })
    this.setState({
      file: file,
      openModal: false,
      openShaireModal: true,
      video: video,
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loading !== this.props.loading) {
      this.setState({
        loading: this.props.loading
      })
    }
  }

  render() {
    return (
      <footer className="fixed-bottom">
        <nav className="bottom-nav d-flex align-items-center justify-content-between">
          <a onClick={this.onOpenModaleCamera} className="btn-photo gradient" >
            <IconPhoto />
          </a>
          <ul className="main-menu d-flex align-items-center justify-content-around">
            <li>
              <Link to="/enfants" >
                <MenuAccueil className="img-fluid" />
                <span> {this.props.t('footer.home')}</span>
              </Link>
            </li>
            <li>
              <Link to="/communaute" >
                <MenuCommunaute className="img-fluid" />
                <span> {this.props.t('footer.community')}</span>
              </Link>
            </li>
            <li>
              <Link to="/menus" >
                <MenuMenus className="img-fluid" />
                <span> {this.props.t('footer.menus')}</span>
              </Link>
            </li>
            <li>
              <Link to="/evenements" >
                <MenuEvenements className="img-fluid" />
                <span> {this.props.t('footer.events')}</span>
              </Link>
            </li>
            <li>
              <Link to="/staff" >
                <MenuEquipe className="img-fluid" />
                <span> {this.props.t('footer.team')}</span>
              </Link>
            </li>
            <li>
              <Link to="/creche/infos" onClick={this.handleClickAdmin} >
                <MenuCreche className="img-fluid"
                />
                <span> {this.props.t('footer.creche')}</span>
              </Link>
            </li>
          </ul>
          <InterCom appUser={this.state.appUser} />
        </nav>
        {
          this.state.openModal === true ?
            <CameraComponent openModal={this.state.openModal}
              onCloseModaleCamera={this.onCloseModaleCamera}
              onOpenSaireModale={this.onOpenSaireModale}
              onOpenShareVideoModale={this.onOpenShareVideoModale}
            /> : ""
        }

        {
          this.state.openShaireModal === true ?
            <ShaireModal openModal={this.state.openShaireModal}
              onCloseModaleCamera={this.onCloseModaleCamera}
              values={this.state}
              shaireWith={this.shaireWith}
              BackCamera={this.BackCamera}
              loading={this.state.loading}
              cleanData={this.cleanData}
            /> : ""
        }

        {
          this.state.openSelectModal === true ?
            <SelectParentModal openModal={this.state.openSelectModal}
              onCloseModaleCamera={this.onCloseModaleCamera}
              values={this.state}
              dataPost={this.props.dataPost}
              loading={this.state.loading}
              cleanData={this.cleanData}

            /> : ""
        }
      </footer>
    );
  }
}


const mapStateToProps = (state) => ({
  dataPost: state.Communaute.data,
  media: state.Communaute.data.media,
  loading: state.Communaute.loading,
  error: state.Communaute.error,
})


export default connect(mapStateToProps, {})(withTranslation()(Footer));